// extracted by mini-css-extract-plugin
module.exports = {"heading":"voucher-campaign-column_heading__2dP3e"};